export enum AbstractionToken {
	ETH = 'ETH',
	USDC = 'USDC',
}
